const baseColor = "#29275B"

/**
 * Creates an SVG element containing fill patterns for map backgrounds.
 * - Uses #C6BFD6 as the base color.
 * - For accessibility mode, uses a slightly darker opacity.
 *
 * @param showAccessibleBackground - Whether to show the accessibility pattern.
 * @returns SVGElement with patterns defined.
 */
export function createBackgroundPatternSvg(showAccessibleBackground = false) {
  const svgNS = "http://www.w3.org/2000/svg"
  const svg = document.createElementNS(svgNS, "svg")
  svg.setAttribute("width", "0")
  svg.setAttribute("height", "0")
  svg.setAttribute("style", "position:absolute")
  svg.setAttribute("id", "geojson-patterns")

  if (showAccessibleBackground) {
    const originPattern = document.createElementNS(svgNS, "pattern")
    originPattern.setAttribute("id", "origin-diagonal")
    originPattern.setAttribute("patternUnits", "userSpaceOnUse")
    originPattern.setAttribute("width", "32")
    originPattern.setAttribute("height", "32")
    originPattern.innerHTML = `
        <rect width="32" height="32" fill="${baseColor}" fill-opacity="0.22" />
        <path d="M0,32 L32,0" stroke="${baseColor}" stroke-width="2" opacity="0.5" />
      `

    const destPattern = document.createElementNS(svgNS, "pattern")
    destPattern.setAttribute("id", "destination-dots")
    destPattern.setAttribute("patternUnits", "userSpaceOnUse")
    destPattern.setAttribute("width", "32")
    destPattern.setAttribute("height", "32")
    destPattern.innerHTML = `
        <rect width="32" height="32" fill="${baseColor}" fill-opacity="0.22" />
        <path d="M0,32 L32,0" stroke="${baseColor}" stroke-width="2" opacity="0.5" />
      `

    svg.appendChild(originPattern)
    svg.appendChild(destPattern)
  } else {
    const originPattern = document.createElementNS(svgNS, "pattern")
    originPattern.setAttribute("id", "origin-diagonal")
    originPattern.setAttribute("patternUnits", "userSpaceOnUse")
    originPattern.setAttribute("width", "16")
    originPattern.setAttribute("height", "16")
    originPattern.innerHTML = `
        <rect width="16" height="16" fill="${baseColor}" fill-opacity="0.25" />
      `

    const destPattern = document.createElementNS(svgNS, "pattern")
    destPattern.setAttribute("id", "destination-dots")
    destPattern.setAttribute("patternUnits", "userSpaceOnUse")
    destPattern.setAttribute("width", "16")
    destPattern.setAttribute("height", "16")
    destPattern.innerHTML = `
        <rect width="16" height="16" fill="${baseColor}" fill-opacity="0.25" />
      `

    svg.appendChild(originPattern)
    svg.appendChild(destPattern)
  }

  return svg;
}